import React from "react";
import { Link } from "react-router-dom";
import "./AboutComp.css";

const INTRO = [
  "The Crypto Hub is a marketing & fundraising platform for Blockchain, Crypto and Web3 projects. We combine media, events and direct access to our community of Investors, Mentors & KOLs to accelerate the teams we back.",
  "We are building the one-stop platform for vetted and curated early-stage projects, connecting them with key investors while fostering an inclusive ecosystem for the Web3 community. Our mission is to empower innovators and entrepreneurs by providing them with the resources, guidance, and network they need to succeed in the rapidly evolving blockchain landscape.",
  "We believe in the transformative power of decentralized technologies and strive to create an environment where groundbreaking ideas can thrive. By offering rigorous project vetting processes, mentorship opportunities, and access to a diverse pool of investors, we aim to bridge the gap between visionary projects and the support they need to reach their full potential.",
  "Join us as we revolutionize the future of finance and technology, ensuring that every participant in the CryptoHub ecosystem can contribute to and benefit from the growth of Web3.",
];

const SERVICES = [
  {
    label: "Advisory",
    description:
      "Growth & market readiness for early stage projects from ideation to token launch, exchange listings & market making. Over the years we have helped projects with their tokenomics, business planning & go to market strategies.",
  },
  {
    label: "Marketing",
    description:
      "Customised marketing built for Web3 — growth & brand building through our internal expertise and through our partners, including leading media & KOLs.",
  },
  {
    label: "Events",
    description:
      "Curated meetups, demo days & summits bringing together founders, investors & our community, alongside partnerships with the top Crypto & Web3 events worldwide.",
  },
  {
    label: "Media",
    description:
      "A premier media channel with a Podcast, Blog & Newsletter sharing news and stories of founders, KOLs and the markets with our growing global community.",
  },
];

const AboutComp = () => (
  <div className="mainAbout">
    <div className="txtAboutHead">About Us</div>

    <div className="topTextAboutPart">
      {INTRO.map((paragraph) => (
        <p key={paragraph}>{paragraph}</p>
      ))}

      <p className="txtAboutSubHead">What We Do</p>

      {SERVICES.map((service) => (
        <p key={service.label}>
          <strong>{service.label}</strong> — {service.description}
        </p>
      ))}

      <p className="txtAboutSubHead">Join Us</p>

      <p>
        Apply as a founder or investor and become part of the ecosystem —{" "}
        <Link to="/user/join/crypto?role=founder">apply here</Link>, or{" "}
        <Link to="/user/contact">get in touch</Link> if you would like to talk
        to us first.
      </p>
    </div>
  </div>
);

export default AboutComp;
